import { CanActivateFn, Router } from '@angular/router';
import { catchError, EMPTY, finalize, Observable, of } from 'rxjs';
import { AuthManagerService } from '@app/core/services/auth-manager.service';
import { IdentityApiService } from '@app/core/services/identity.service';
import { inject } from '@angular/core';
import { UserPreferenceManagerService } from '@app/api/user-preference/user-preference-manager.service';
import { UserProfileManagerService } from '@app/api/user-profile/user-profile-manager.service';

export const authGuard: CanActivateFn = (): Observable<boolean> => {
    const authManager = inject(AuthManagerService);
    const identity = inject(IdentityApiService);
    const router = inject(Router);
    const userProfileManager = inject(UserProfileManagerService);
    const userPreferenceManager = inject(UserPreferenceManagerService);

    if (authManager.isLoggedIn) { return of(true); }

    return new Observable(observer => {
        // Does not depend on the identity response; starting it now saves the layout's render delay before the boot reads it.
        // The manager shares this one request with every later caller. A failure surfaces again when they ask.
        userPreferenceManager.getUserPreferences().pipe(catchError(() => EMPTY)).subscribe();

        identity.getIcentralUserDetails()
            .pipe(finalize(() => observer.complete()))
            .subscribe({
                next: response => {
                    // The layout reads this same user next; seeding the cache saves it a second identity round trip.
                    if (response.body) { userProfileManager.cacheCurrentUser(response.body); }
                    observer.next(true);
                },
                error: () => {
                    router.navigate(['/login']);
                    observer.next(false);
                }
            });
    });
};
